import React, {  useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HashRouter as Router, Switch, Route } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Login from "./components/Login";
import Register from "./components/Register";
import Home from "./components/Home";
import NotFound from "./components/NotFound";
import Profile from "./components/Profile";
import RadarChart from "./components/RadarChart";
import BoardUser from "./components/BoardUser";
import BoardModerator from "./components/BoardModerator";
import BoardAdmin from "./components/BoardAdmin";
import PlantSearch from "./components/PlantSearch";
import Groups from "./components/Groups";
// import Chat from "./components/Chat";
import Footer from "./components/Footer";
import Drone from "./components/Drone";
import PhenotypeReports from "./components/PhenotypeReports";
import Header from "./components/Header";

import { logout } from "./slices/auth";
import EventBus from "./common/EventBus";

const App = () => {
  // const [showModeratorBoard, setShowModeratorBoard] = useState(false);
  // const [showAdminBoard, setShowAdminBoard] = useState(false);
  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const logOut = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  useEffect(() => {
    // if (currentUser) {
    //   setShowModeratorBoard(currentUser.roles.includes("ROLE_MODERATOR"));
    //   setShowAdminBoard(currentUser.roles.includes("ROLE_ADMIN"));
    // } else {
    //   setShowModeratorBoard(false);
    //   setShowAdminBoard(false);
    // }

    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, [currentUser, logOut]);

  return (
    <Router>
        <div className="bg-Verinomics">
          <Header />
          <div className="container mt-3">
            <Switch>
              <Route exact path={["/", "/home"]} component={Home} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/register" component={Register} />
              <Route exact path="/profile" component={Profile} />
              <Route excat path="/search" component={PlantSearch} />
              <Route excat path="/groups" component={Groups} />
              <Route excat path="/charts" component={RadarChart} />
              {/* <Route excat path="/chat" component={Chat} /> */}
              <Route excat path="/drone" component={Drone} />
              <Route exact path="/reports" component={PhenotypeReports} />


              <Route path="/user" component={BoardUser} />
              <Route path="/mod" component={BoardModerator} />
              <Route path="/admin" component={BoardAdmin} />
              <Route path="*" element={<NotFound />} /> {/* Catch-all route for 404 */}

            </Switch>
          </div>
        </div>
      <Footer />
    </Router>

  );
};

export default App;

